/**
 * @typedef {Object} TrackerService
 *
 * @property {function} logKISClick
 * @property {function} logKISReturn
 */


(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'TrackerService', [ '$analytics', '$cookies', 'LoggerFactory', 'CONFIG', TrackerService ]);


     /**
     * Provides set of tracking tools for the Google Analytics and Google Tag
     * Manager (GTM) service.
     *
     * @param {analytics} $analytics
     * @param {$cookies} $cookies
     * @param {LoggerFactory} LoggerFactory
     * @param {Object} CONFIG
     *
     * @returns {TrackerService}
     */
    function TrackerService(
        $analytics,
        $cookies,
        LoggerFactory,
        CONFIG
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        LoggerFactory.createLogger( 'TrackerService', false );


        /** @constant */
        var COOKIE_KIS = {
            EXPIRATION_DAYS:    7,
            ID:                 'GAEventKIS'
        },

        COOKIE_PATH =   '/',
        COOKIE_DOMAIN = CONFIG.COOKIE_DOMAIN;



        /** @type {TrackerService} */
        var service = {

            // Methods
            logKISClick:   logKISClick,
            logKISReturn:  logKISReturn
        };



        ////////////////////////////////////////////////////////////////////////

        return service; // Expose API

        ////////////////////////////////////////////////////////////////////////



        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Logs an event about user clicking through the `KIS` (key information
         * for students) element as a Google Analytic's event.
         */
        function logKISClick() {
            // Set cookie
            var expireDate = new Date();

            expireDate.setDate( expireDate.getDate() + COOKIE_KIS.EXPIRATION_DAYS );

            $cookies.putObject( COOKIE_KIS.ID, { createdAt: new Date() }, { expires: expireDate, path: COOKIE_PATH, domain: COOKIE_DOMAIN } );

            // Log KIS event
            $analytics.eventTrack( CONFIG.ANALYTICS.EVENT.KIS_CLICK, {
                category:   CONFIG.ANALYTICS.CATEGORY.KIS
            });
        }


        /**
         * Logs an event about user returning to the app AFTER
         * leaving it through click on the the `KIS` element (within
         * specific time period).
         */
        function logKISReturn() {
            var dateNow = new Date(),
            KISCookie   = $cookies.getObject( COOKIE_KIS.ID );

            if ( KISCookie ){

                // Cookie exists -> 1. User has returned, remove the cookie and create an event
                $cookies.remove( COOKIE_KIS.ID, { path: COOKIE_PATH, domain: COOKIE_DOMAIN } );

                // How much time has passed between the click and return in seconds
                var secondsDifference = Math.abs( dateNow - new Date( KISCookie.createdAt ) ) / 1000;

                var label = '';

                if ( secondsDifference <= 60 ) {
                    label = "Return within a minute";
                } else if ( secondsDifference <= ( 60 * 10 ) ) {
                    label = "Return between 1 and 10 minutes";
                } else if ( secondsDifference <= ( 60 * 60 ) ) {
                    label = "Return between 10 and 60 minutes";
                } else if ( secondsDifference <= ( 60 * 60 * 24 ) ) {
                    label = "Return between 1 and 24 hours";
                } else {
                    label = "Return between 1 and 7 days";
                }

                // 2. Log an event
                $analytics.eventTrack( CONFIG.ANALYTICS.EVENT.KIS_RETURN, {
                    category:   CONFIG.ANALYTICS.CATEGORY.KIS,
                    value:      secondsDifference,
                    label:      label
                });
            }
        }


    }
})();
